import ActionTypes from "../../../constants/ActionTypes";
import { IAvailabilityProduct, IGetAvailabilityProductActions, ISetAvailabilityProductActions, ISetAvailabilityProductLoaderAction } from "./types";


export function setAvailabilityProduct(availabilityProduct: IAvailabilityProduct): ISetAvailabilityProductActions {
  return {
    type: ActionTypes.AVAILABILITY_PRODUCT.SET,
    payload: availabilityProduct,
  };
}

export function getAvailabilityProduct(
  productId: string | number,
  colorId: string | number,
  storeId: string | number,
  lang: string
): IGetAvailabilityProductActions {
  return {
    type: ActionTypes.AVAILABILITY_PRODUCT.GET,
    params: {
      productId: productId,
      colorId: colorId,
      storeId: storeId,
      lang: lang
    }
  };
}

export function setAvailabilityProductLoader(
  isLoading: boolean
): ISetAvailabilityProductLoaderAction {
  return {
    type: ActionTypes.AVAILABILITY_PRODUCT.SET_LOADER,
    payload: {
      isLoading
    }
  };
}
